import React, { useMemo, useRef, useState } from "react";
import MuxPlayer from "@mux/mux-player-react";
import "./MuxWidePlayer.css";

const MuxWidePlayer = ({ playbackId, title = "Job Peeks video", poster }) => {
  const playerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const posterUrl = useMemo(() => {
    if (poster) return poster;
    if (!playbackId) return null;

    return `https://mux.jobpeeks.com/${playbackId}/thumbnail.jpg?time=0&width=1920&height=1080&fit_mode=smartcrop`;
  }, [playbackId, poster]);

  if (!playbackId) return null;

  const playVideo = () => {
    const player = playerRef.current;
    const media = player?.media?.nativeEl || player;

    if (media?.play) {
      media.play().catch(() => {});
    }
  };

  return (
    <div
      className="how-it-works-mux-shell"
      style={{ position: "relative", width: "100%", height: "100%" }}
    >
      <MuxPlayer
        ref={playerRef}
        playbackId={playbackId}
        streamType="on-demand"
        playsInline
        controls={isPlaying}
        thumbnailTime={0}
        poster={posterUrl}
        className={`how-it-works-mux-player ${
          isPlaying ? "is-playing" : "is-paused"
        }`}
        aria-label={title}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
        style={{
          "--media-object-fit": "cover",
          "--media-accent-color": "#7064e9",
          width: "100%",
          height: "100%",
          position: "relative",
          zIndex: 1,
        }}
      />
      {!isPlaying && (
        <>
          <div
            className="how-it-works-mux-overlay"
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: 0,
              zIndex: 2,
              pointerEvents: "none",
              background:
                "linear-gradient(180deg, rgba(3, 4, 16, 0.28) 0%, rgba(3, 4, 16, 0.18) 42%, rgba(3, 4, 16, 0.62) 100%), radial-gradient(circle at 50% 45%, rgba(3, 4, 16, 0.04) 0%, rgba(3, 4, 16, 0.12) 45%, rgba(3, 4, 16, 0.52) 100%)",
            }}
          />
          <button
            type="button"
            className="how-it-works-mux-play"
            aria-label={`Play ${title}`}
            onClick={playVideo}
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 3,
              width: "86px",
              height: "86px",
              borderRadius: "50%",
              border: "1px solid rgba(255, 255, 255, 0.38)",
              background:
                "linear-gradient(135deg, rgba(221, 0, 172, 0.95), rgba(112, 100, 233, 0.95))",
              color: "#fff",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 18px 55px rgba(112, 100, 233, 0.42)",
              cursor: "pointer",
            }}
          >
            <i
              className="feather-play"
              aria-hidden="true"
              style={{ fontSize: "34px", marginLeft: "5px" }}
            />
          </button>
        </>
      )}
    </div>
  );
};

export default MuxWidePlayer;
